import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../../../app.service';
import { Observable } from 'rxjs';

export interface TaskStatusResponse {
    taskId: string;
    number: string;
    state: string;
    stateDescription: string;
    type: string;
    subType: string;
    customerType: string;
    ticketType: string;
    skill: string[];
    subSkill: string[];
    fechaCita: string;
}

@Injectable({
    providedIn: 'root'
})
export class Task4WorkService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        private appService: AppService,
    ) {
        this.appData = appService.settings;
    }

    getTaskStatus(taskId: string): Observable<TaskStatusResponse> {
        return this.httpClient.get<TaskStatusResponse>(`${this.appData.webApi}/task4work/tasks/v1/task/${taskId}`);
    }

    cancelTask(taskId: string): Observable<TaskStatusResponse> {
        return this.httpClient.get<TaskStatusResponse>(`${this.appData.webApi}/task4work/tasks/v1/task/${taskId}/cancel`);
    }

}
